// Internal enum, defining how to add member
enum AddUserSpaceMemberMethod {
    // Add invite directly by user ID
    UserID = 'user_id',

    // Generate and send invite to the email
    Invite = 'invite',
}

export default AddUserSpaceMemberMethod;
